









































































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import OrganizerResourceListFilters from '@superUI/ResourceList/OrganizerResourceListFilters'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'OrganizerResourceList'
  components: {
    Modal,
    Trigger,
    ResourceList,
    OrganizerResourceListFilters,
    LoadingIndicator
  }

  vue:
    props: ['organizers', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      pageNumber: 1
      selectedOrganizers: []
      selectedFilters: []

      sortList: [
        { field: 'ctx.supplier.org.name', value: 'Supplier' }
        { field: 'email', value: 'Email' }
        { field: 'first_name', value: 'First Name' }
        { field: 'last_name', value: 'Last Name' }
        { field: 'admin', value: 'Admin' }
        { field: 'contact_for_sponsorships', value: 'Contact for Sponsorships' }
        { field: 'contact_for_insurance', value: 'Contact for Insurance' }
        { field: 'transfer_account_at', value: 'Transfer Account At' }
        { field: 'role', value: 'Role' }
        { field: 'created_at', value: 'Created At' }
        { field: 'updated_at', value: 'Updated At' }
        { field: 'onboarded_at', value: 'Onboarded At' }
        { field: 'trusted_at', value: 'Trusted At' }
        { field: 'recess_verified_at', value: 'Recess Verified At' }
        { field: 'last_emailed_at', value: 'Last Emailed At' }
      ]
      sortValue: ''

      filters:
        scopes:
          member: null
          workflow: null
          published: null
          offers: null
          events: null
          potential_events: null
          recurrence: null
          horizon: null
          onboarding: null
          supplier: null

        filters:
          created_after: ''
          created_before: ''

        q: ''
        sort: [{ field: 'created_at', order: 'desc' }]

      verifyModal:
        show: false
        eventId: null

      switchUserModal:
        show: false
        rep: null

      deleteModal:
        modalOptions:
          title: 'Delete Organizer'
          button:
            label: 'Delete'
            type: 'danger'

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'organizer-resource-list-item': () => import('./OrganizerResourceListItem')
        }
      title: ->
        @options?.title || 'Organizers'

      resourceKey: ->
        @options?.resourceKey || 'organizers'

      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      deleteTriggerResource: ->
        { key: @resourceKey, triggerName: 'delete', component: @$parent.$parent }
      deleteTriggerPayload: ->
        payload =
          organizer_ids: @selectedOrganizers.map((e) -> e.id)
        payload

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      buttonTypeForFilter: (scope, key, attr) ->
        return 'primary' if @[scope][key] is attr
        return 'text'

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}

        timeWindows = payload.filters
        for field, timeWindow of timeWindows
          delete timeWindows[field] if not timeWindow

        payload

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @filters.scopes = cleared_filter_scope
        @hiFilterChange()

      handleVerifyClicked: (eventId) ->
        @verifyModal.eventId = eventId
        @verifyModal.show = true

      hiPromptToSwitchUser: (rep)->
        event.stopPropagation()
        @switchUserModal.rep = rep
        @switchUserModal.show = true

      hiSwitchUser: (rep)->
        @switchUserModal.show = false
        @switchUser rep.member_id

      hiToggleSelection: (event) ->
        if @selectedOrganizers.includes(event)
          @selectedOrganizers = @selectedOrganizers.filter((item) -> item.id != event.id)
        else
          @selectedOrganizers.push(event)

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange()

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = flippedOrder if item.field == sort.field
          item
        )
        @hiFilterChange()

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'

        return 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) -> item.field == field).value

export default VueOptions.vue settings
